<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <ToastViewport />
  <ContactWidget />
</template>
